module.exports = __webpack_public_path__ + "static/media/King Skorn.9937b4ce.png";